<template>
      <crud-delete :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @delete="remove"
                 @close="$emit('close')"
    >

        <v-card-text>
          <producto-show-data :item="item" />
        </v-card-text>

        <v-card-text>
            <v-row justify="center">
                <span class="title">{{areYouSure}}</span>
            </v-row>
        </v-card-text>

    </crud-delete>
</template>

<script>
    //Provider  
    import ProductoProvider from "../../../providers/ProductoProvider";
    
    //Show Data
    import ProductoShowData from "../ProductoShow/ProductoShowData";
    
    //Common
    import {CrudDelete} from '@dracul/common-frontend'
import ClientError from "@/errors/ClientError";
    
    export default {
        name: "ProductoDelete",
        
        components: {ProductoShowData, CrudDelete},
        
        props: {
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },
        
        data() {
            return {
                modal: false,
                title: 'producto.deleting',
                areYouSure: this.$t('common.areYouSureDeleteRecord'),
                errorMessage: '',
                loading: false,
            }
        },
        methods: {
            remove() {
                this.loading = true
                ProductoProvider.deleteProducto(this.item.id).then(result => {
                            if (result.data.productoDelete.success) {
                                this.$emit('itemDeleted',result.data.productoDelete)
                                this.$emit('close')
                            }else{
                                this.errorMessage = 'Error on Delete'
                            }
                        }
                    ).catch(error =>{
                        let clientError = new ClientError(error)
                        this.errorMessage = clientError.showMessage
                }).finally(() => this.loading = false)
            },
        },
    }
</script>


